/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
import { Loader } from '@nile/components';
import {
  GET_CONVERSATION_FEEDS,
  GET_TICKET_AUDIT,
  GET_TICKET_AUDIT_LIST
} from '@nile/graphql';
import React from 'react';
import styled from 'styled-components';
import { Avatar } from '@superops/ui-design-system';
import dompurify from 'dompurify';
import { useLazyQuery } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import Tippy from '@tippyjs/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const InfoPopupCardContainer = styled.div`
  padding: 12px;
  min-width: 400px;
  max-width: 600px;
  max-height: 400px;
  overflow: scroll;
  position: relative;
  .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    margin-top: 0;
  }
  .subtitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.6);
  }
  .details {
    column-gap: 40px !important;
  }
  line-break: anywhere;
  img {
    max-width: 100%;
  }
`;

const NodescriptionContainer = styled.div`
  display: flex;
  padding: 5px 10px;
`;

const Item = styled.div`
  height: 24px;
  line-height: 20px;
  background: #f2f5ff;
  padding: 2px 8px 2px 1px;
`;

const LoaderContainer = styled.div`
  width: 200px;
  height: 100px;
`;

const TicketInfoPopupTippy = ({ activator, data, onPopupClick }) => {
  const [
    getTicketAuditList,
    { loading: feedsLoading, error: auditListError, data: auditList }
  ] = useLazyQuery(GET_TICKET_AUDIT_LIST);

  // if (feedsError) return <>Error...</>;

  const firstFeedConversation = auditList?.getTicketAuditList?.ticketAudit?.[0];

  const isUnknownTicket = data?.unknownTicket;

  // const unknownTicketDescription = auditList?.getTicketAuditList?.[0];

  return (
    <Tippy
      content={
        feedsLoading ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : firstFeedConversation?.conversation?.content ? (
          <InfoPopupCardContainer className="white-to-grey-bg">
            {isUnknownTicket &&
              (firstFeedConversation?.conversation?.user?.email ||
                firstFeedConversation?.user?.email) && (
                <div className="fx pb10 actr">
                  <h4 className="title mr-5">
                    <FormattedMessage id="ticket.details.chat.from" />:
                  </h4>
                  <div>
                    {firstFeedConversation?.conversation?.user?.email ||
                      firstFeedConversation?.user?.email}
                  </div>
                </div>
              )}
            {isUnknownTicket &&
              firstFeedConversation?.conversation?.toUsers?.length && (
                <div className="fx fw pb-5">
                  <h4 className="title mr-5 min-width-30">
                    <FormattedMessage id="ticket.details.chat.to" />:
                  </h4>
                  <div className="fx wrap">
                    {firstFeedConversation.conversation.toUsers.map(
                      (userData) => {
                        return (
                          <Item className="fx actr mr-5 mb-3 f-14 br10 text-medium">
                            <Avatar
                              name={userData?.user?.email}
                              initials={userData?.user?.email[0]}
                              size="extraSmall"
                            />
                            <div className="ml-5">{userData?.user?.email}</div>
                          </Item>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            {isUnknownTicket &&
              firstFeedConversation?.conversation?.ccUsers?.length && (
                <div className="fx fw pb-5">
                  <h4 className="title mr-5 min-width-30">
                    <FormattedMessage id="ticket.details.recepient.cc" />:
                  </h4>
                  <div className="fx wrap">
                    {firstFeedConversation.conversation.ccUsers.map(
                      (userData) => {
                        return <span>{userData?.user?.email}</span>;
                      }
                    )}
                  </div>
                </div>
              )}
            {isUnknownTicket &&
              firstFeedConversation?.conversation?.bccUsers?.length && (
                <div className="fx fw pb-5">
                  <h4 className="title mr-5 min-width-40">
                    <FormattedMessage id="ticket.details.recepient.bcc" />:
                  </h4>
                  <div className="fx wrap">
                    {firstFeedConversation.conversation.bccUsers.map(
                      (userData) => {
                        return <span>{userData?.user?.email}</span>;
                      }
                    )}
                  </div>
                </div>
              )}
            <h4 className="title pb10">
              <FormattedMessage id="ticketlist.popup.description.title" />:
            </h4>
            <div
              dangerouslySetInnerHTML={{
                __html: dompurifier(
                  firstFeedConversation?.conversation?.content,
                  {
                    FORBID_TAGS: ['style']
                  }
                )
              }}
            />
          </InfoPopupCardContainer>
        ) : (
          <NodescriptionContainer className="white-to-grey-bg">
            <FormattedMessage id="ticketlist.popup.nodescription.title" />
          </NodescriptionContainer>
        )
      }
      maxWidth={600}
      delay={500}
      duration={250}
      interactive
      placement="right"
      arrow={false}
      theme="light"
      allowHTML
      appendTo={document.body}
      offset={[0, 20]}
      onShow={() => {
        // eslint-disable-next-line no-unused-expressions
        getTicketAuditList({
          variables: {
            input: {
              ticket: { ticketId: data?.ticketId },
              listInfo: {
                condition: {
                  joinOperator: 'AND',
                  operands: [
                    {
                      attribute: 'conversation.type',
                      operator: 'is',
                      value: 'DESCRIPTION'
                    }
                  ]
                }
              }
            }
          }
        });
      }}
    >
      <div>{activator}</div>
    </Tippy>
  );
};

export default TicketInfoPopupTippy;
